/**
 * /server-error — 500 fault route.
 *
 * Round 5 Item 7 Tier 1 #3. Rendered by the top-level ErrorBoundary
 * (apps/ui/src/components/ErrorBoundary.tsx) when an unhandled React
 * throw bubbles up, AND by app routes that catch a 500 from a Pages
 * Function and explicitly redirect here.
 *
 * The ErrorBoundary writes an audit row to sys__incident via
 * `/api/me/incidents/report` (best-effort fire-and-forget — never blocks
 * the rendered fault page). Pattern 5/Tier 1 isolation: operator-only,
 * not surfaced to customer UI; Ean + Josh see it via Neon MCP queries on
 * `sys__incident` until the control lane Phase 2 surface ships.
 *
 * The user gets a calm message + "Try again" + "Back to Home" — never a
 * stack trace, never a Cloudflare ray ID front-and-center. The Sentry-
 * style "we've been notified" line is true: the incident row IS the
 * notification.
 */

import {
  BrandedFaultRoute,
  FaultCtaHome,
  FaultCtaRetry,
} from '../components/BrandedFaultRoute.tsx';

export function ServerError() {
  return (
    <BrandedFaultRoute
      kind="error"
      iconKind="activity"
      eyebrow="Server hiccup"
      title="Something hiccupped on our end."
      body="We've been notified and we're looking into it. Try again, or head back to your home."
      actions={
        <>
          <FaultCtaRetry />
          <FaultCtaHome label="Back to Home" />
        </>
      }
      fineprint={
        <span>If this keeps happening, mention it via the Help menu.</span>
      }
    />
  );
}
